
import Vue from "vue";
import axios from "axios";
import MessageSender from './../Messaging/MessageSender.vue';
import MessageListItem from "../Messaging/MessageListItem.vue";
import MessageViewer from "../Messaging/MessageViewer.vue";
import { MessengerEditorMode } from '../../../enums/Messaging/MessengerEditorMode';
import { DashboardMessages, UserMessage } from '../../../types/Sapphire_dto';

export default Vue.extend({
    name: "dashboard-messaging",
    props: {
        usr: String,
        fac: String
    },
    components: {
        MessageSender,
        MessageListItem,
        MessageViewer
    },
    data: function () {
        return {
            MessengerEditorMode,
            viewMode: MessengerEditorMode.NewMessage,
            pageSize: 10,
            isLoading: true,
            isErrored: false,
            messageData: new Object() as DashboardMessages,
            messageMode: MessengerEditorMode,
            selectedMessage: new Object() as UserMessage,
            showViewer: false,
            showSender: false
        }
    },
    watch: {
        fac: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.loadMessages();
            }
        },
    },
    methods: {
        changeInboxMode: function (btn) {

            this.resetPageSize();

            document.querySelector(".messages-selected-folder").classList.remove("messages-selected-folder");

            btn.classList.add("messages-selected-folder");

            switch (btn.id) {
                case "btnInbox":
                    this.viewMode = MessengerEditorMode.NewMessage;
                    break;
                case "btnSent":
                    this.viewMode = MessengerEditorMode.Reply;
                    break;
                case "btnSaved":
                    this.viewMode = MessengerEditorMode.Forward;
                    break;
            }

            this.loadMessages();

        },
        reloadUserMessages: function (mode, pgSize) {
            this.viewMode = mode;
            this.pageSize = pgSize;
            this.loadMessages();
        },
        async loadMessages() {

            this.isErrored = false;
            this.isLoading = true;

            try {
                const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetUserMessagesForDashboard_Vue",
                {
                    pageSize: this.pageSize,
                    viewMode: this.viewMode,
                    currentPage: 1,
                    urgent: '',
                    messageType: ''
                });
                
                 this.messageData = JSON.parse(response.data.d);
                //this.messageData = response.data.d;
                this.isLoading = false;

            } catch (err) {
                this.isErrored = true;
            }

            this.isLoading = false;
 
        },
        loadMoreMessages: function () {
            if (this.pageSize <= this.messageData.MessageCount) {
                this.pageSize += 10;
                this.loadMessages();
            }
        },
        resetPageSize: function () {
            this.pageSize = 10;
        },
        // onMethodFailed: function (jqXHR, statusText, errorThrown, serviceUrl) {
        //     window.location.href = "../../Common/Pages/SessionTimedOut.aspx?Timeout=True";
        // },
        showViewerPopup: function (msg) {
            this.selectedMessage = msg;
            this.showViewer = true;
        },
        closeViewerPopup: function () {
            this.selectedMessage = new Object as UserMessage;
            this.showViewer = false;
        },
        showSenderPopup: function (msg: UserMessage, msgMode){
            this.selectedMessage = msg;
            this.messageMode = msgMode;
            this.showSender = true;
        },
        closeSenderPopup: function () {
            this.selectedMessage = new Object as UserMessage;
            this.showSender = false;
        },
        forward: function (msg) {
            this.showSenderPopup(msg, MessengerEditorMode.Forward);
        },
        replyAll: function (msg) {
            this.showSenderPopup(msg, MessengerEditorMode.ReplyAll);
        },
        reply: function (msg) {
            this.showSenderPopup(msg, MessengerEditorMode.Reply);
        },
        newMsg: function () {
           this.showSenderPopup(null, MessengerEditorMode.NewMessage);
        }
    }
});
